import React from "react";
import LoginContainer from "../../../containers/Auth/Login";

const LoginScreen = ({ listConfig }) => {
  return <LoginContainer listConfig={listConfig} />;
};
export default LoginScreen;
